
import { toRefs, reactive, computed, getCurrentInstance, onMounted } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store/index.ts'
// import { Expand, Fold } from '@element-plus/icons'
export default {
  name: 'layoutBreadcrumb',
  // components: { Expand, Fold },
  setup () {
    const { proxy } = getCurrentInstance() as any
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const state: any = reactive({
      breadcrumbList: [],
      routeSplit: [],
      routeSplitFirst: '',
      routeSplitIndex: 1
    })
    // 获取布局配置信息
    const getThemeConfig = computed(() => {
      return store.state.themeConfig.themeConfig
    })
    // 动态设置经典、横向布局不显示
    const isShowBreadcrumb = computed(() => {
      initRouteSplit(route.path)
      const { layout, isBreadcrumb } = store.state.themeConfig.themeConfig
      if (layout === 'classic' || layout === 'transverse') {
        return 'none'
      } else {
        return isBreadcrumb ? '' : 'none'
      }
    })
    // 面包屑点击时
    const onBreadcrumbClick = (v: any) => {
      const { redirect, path } = v
      if (redirect) router.push(redirect)
      else router.push(path)
    }
    // 展开/收起左侧菜单点击
    const onThemeConfigChange = () => {
      // proxy.mittBus.emit('onMenuClick')
      store.state.themeConfig.themeConfig.isCollapse = !store.state.themeConfig.themeConfig.isCollapse
    }
    // 处理面包屑数据
    const getBreadcrumbList = (arr: Array<object>) => {
      arr.map((item: any) => {
        state.routeSplit.map((v: any, k: number, arrs: any) => {
          if (state.routeSplitFirst === item.path) {
            state.routeSplitFirst += `/${arrs[state.routeSplitIndex]}`
            state.breadcrumbList.push(item)
            state.routeSplitIndex++
            if (item.children) getBreadcrumbList(item.children)
          }
        })
      })
    }
    // 当前路由字符串切割成数组，并删除第一项空内容
    const initRouteSplit = (path: string) => {
      if (!store.state.themeConfig.themeConfig.isBreadcrumb) return false
      state.breadcrumbList = [store.state.routesList.routesList[0]]
      state.routeSplit = path.split('/')
      state.routeSplit.shift()
      state.routeSplitFirst = `/${state.routeSplit[0]}`
      state.routeSplitIndex = 1
      getBreadcrumbList(store.state.routesList.routesList)
    }
    // 页面加载时
    onMounted(() => {
      initRouteSplit(route.path)
    })
    // 路由更新时
    onBeforeRouteUpdate((to) => {
      initRouteSplit(to.path)
    })
    return {
      onThemeConfigChange,
      isShowBreadcrumb,
      getThemeConfig,
      onBreadcrumbClick,
      ...toRefs(state)
    }
  }
}
